import { GenericDownloadView } from "./partials/generic-download";
import { StatuteOutlineView } from "./statute-outline";
import { StatuteOutlineModel } from "./../models/statute-outline";
import { LegislationDocumentModel } from "./../models/legislation-document";
import { GenericDocumentView } from "./generic-document";
import { AppEvents } from "../../app-events";
import { ViewMode } from "../models/document-state";

const dom = {
    STATUTE_OUTLINE_BUTTON: ".btn-statute-outline",
    STAGE_SWITCHER: ".document-navigator",
    STAGE_SELECTED: ".stage-selected"
};

export class LegislationDocumentView extends GenericDocumentView {

    public model: LegislationDocumentModel;
    public statuteOutlineView: StatuteOutlineView;
    public statuteOutlineRegion: Marionette.Region;

    public onShow() {
        super.onShow();
        this.setupOutline();
    }

    public regions(): any {
        const regions = super.regions();

        const myRegions = {
            statuteOutlineRegion: ".statute-outline-region"
        };
        return _.extend(regions, myRegions);
    }

    protected setupDownloadView() {
        const downloadTemplate = this.templateManager.getTemplate("download-legislation", this.model.DocumentAccessSku);
        downloadTemplate.then((template) => {
                this.downloadView = new GenericDownloadView({model: this.model, template: template.Raw});
                this.downloadView.template = template.Raw;
                this.downloadRegion.show(this.downloadView);
        });
    }

    private setupOutline() {
        if (!this.model.Outline) {
            this.$(dom.STAGE_SWITCHER).hide();
            return;
        }
        try {
            this.setupOutlineButtonVisibility();
            this.statuteOutlineView = new StatuteOutlineView({ model: this.model.Outline });
            this.statuteOutlineRegion.show(this.statuteOutlineView);
            this.statuteOutlineView.setActiveSection(this.model.Id);
        } catch (ex) {
            // Region doesn't exist on open sku. This could be refactored
        }
    }
     private setupOutlineButtonVisibility() {
        if (this.model.IsLocalAct) {
            this.$(dom.STAGE_SWITCHER).addClass("disabled");
            this.appEvents.trigger(AppEvents.AppInsightsDocumentPDFView, {MaterialType: "Legislation"});
        }
        this.$(dom.STAGE_SELECTED).text(this.model.getSectionName() + " ").append(`<span class="caret"></span>`);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/legislation-document.ts